var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.filterable')}},[_c('el-switch',{model:{value:(_vm.optionModel.filterable),callback:function ($$v) {_vm.$set(_vm.optionModel, "filterable", $$v)},expression:"optionModel.filterable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }